<template>
  <nav-bar title="调整非法经营企业"/>
  <van-search v-model="words" @search="handleSearch" placeholder="请输入搜索关键词" />
  <Content :bottom="0" :top="102">
    <Loading v-if="showLoading" :isLoading="isLoading" @reload="getDataLoading(words)"/>
    <ul v-if="list.length" class="company-list">
      <li v-for="item in list" :key="item.cid" @click="$router.push(`/adjustAEnterpriseDetail/${item.cid}/${item.cname}`)" class="company-list-item">
        <div class="company-list-item__title">{{item.cname}}</div>
      </li>
    </ul>
    <Empty v-else :description="description" />
  </Content>
</template>

<script>
import { ref, computed } from 'vue'
import { queryIllegalCompanyList } from '@/api/companyList'
import { useGetDataLoading, showLoading, isLoading } from '@/hooks/useGetDataLoading'
import { useStore } from 'vuex'
export default {
  name: 'AdjustAEnterprise',
  setup () {
    const words = ref('')
    const description = ref('请搜索企业名称')
    const list = ref([])
    const store = useStore()
    const tenantId = computed(() => store.state.roleInfo.tenantId)
    const { getDataLoading } = useGetDataLoading(queryIllegalCompanyList, (data) => {
      // console.log(data)
      list.value = data || []
      description.value = '没有搜索相关企业'
    })
    const handleSearch = (word) => {
      getDataLoading({
        comName: word,
        tenantId: tenantId.value
      })
    }
    return { handleSearch, words, showLoading, isLoading, getDataLoading, list, description }
  }
}
</script>

<style lang="scss" scoped>
.company-list {
  padding: 16px 16px 0 16px;
  .company-list-item {
    padding: 10px 16px;
    font-size: 16px;
    background-color: #fff;
    display: flex;
    align-items: center;
    box-shadow: rgba(9, 30, 66, 0.25) 0px 4px 8px -2px, rgba(9, 30, 66, 0.08) 0px 0px 0px 1px;
    margin-bottom: 16px;
    color: #666;
    &__title {
      flex: 1;
      margin-right: 10px;
    }
  }
}
</style>
